(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["more-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('more-colors-block')) {
    class MoreColorsBlock extends HTMLElement {
      constructor() {
        super();
        this.links = this.querySelectorAll('.more-colors__link');
        this.nameDisplay = this.querySelector('.more-colors__dynamic-name');
        this.scrollContainer = this.querySelector('.more-colors__list');
        this.progressContainer = this.querySelector('.more-colors__progress');
        this.progressFill = this.querySelector('.more-colors__progress-fill');
        
        // Setup Hover Labels
        if (this.nameDisplay) {
          const activeLink = this.querySelector('.is-active .more-colors__link');
          this.defaultName = activeLink ? activeLink.getAttribute('data-color-name') : '';
          this.nameDisplay.textContent = this.defaultName;
          this.bindHoverEvents();
        }

        // Setup Scrollbar Indicator
        if (this.scrollContainer && this.progressContainer && this.progressFill) {
          this.updateProgress = this.updateProgress.bind(this);
          
          // Initial calculation
          this.updateProgress();

          // Listeners for interaction and resizing
          this.scrollContainer.addEventListener('scroll', () => requestAnimationFrame(this.updateProgress), { passive: true });
          window.addEventListener('resize', () => requestAnimationFrame(this.updateProgress));
          
          // If images load late or layout changes from Desktop Grid to Mobile Carousel
          const observer = new ResizeObserver(() => requestAnimationFrame(this.updateProgress));
          observer.observe(this.scrollContainer);
        }
      }

      bindHoverEvents() {
        this.links.forEach(link => {
          link.addEventListener('mouseenter', () => {
            this.nameDisplay.textContent = link.getAttribute('data-color-name');
            this.nameDisplay.style.opacity = '1';
          });
          link.addEventListener('mouseleave', () => {
            this.nameDisplay.textContent = this.defaultName;
            this.nameDisplay.style.opacity = this.defaultName ? '0.6' : '0';
          });
        });
      }

      updateProgress() {
        const scrollWidth = this.scrollContainer.scrollWidth;
        const clientWidth = this.scrollContainer.clientWidth;
        const scrollLeft = this.scrollContainer.scrollLeft;
        
        // Dynamic hiding logic: 
        // On desktop grid, scrollWidth === clientWidth, so it hides automatically.
        // On mobile carousel, scrollWidth > clientWidth, so it shows up seamlessly.
        if (scrollWidth <= clientWidth) {
          this.progressContainer.style.display = 'none';
          return;
        } else {
          this.progressContainer.style.display = 'block';
        }

        const handleScale = clientWidth / scrollWidth; 
        const translatePercentage = (scrollLeft / scrollWidth) * 100;
        
        this.progressFill.style.transform = `translateX(${translatePercentage}%) scaleX(${handleScale})`;
      }
    }
    customElements.define('more-colors-block', MoreColorsBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
